import * as React from "react";
import { IconItalic } from "../../icons";

import { ToolbarToggleButton } from "./ToolbarToggleButton";

export function ItalicButton({ editor, iconSize }): JSX.Element {
  return (
    <ToolbarToggleButton
      onClick={() => editor.chain().focus().toggleItalic().run()}
      isActive={editor?.isActive("italic")}
      title="Курсив"
    >
      <IconItalic size={iconSize} />
    </ToolbarToggleButton>
  );
}
